import React, { createContext, useContext } from "react"

type SurveySubmitContextValue = {
	submitFnRef: React.MutableRefObject<(() => void) | null>
	dismissFnRef?: React.MutableRefObject<(() => void) | null>
	onClosePermanently: () => void
	setIsConfirmDisabled?: (disabled: boolean) => void
}

const SurveySubmitContext = createContext<SurveySubmitContextValue>({} as SurveySubmitContextValue)

export const useSurveySubmit = (): SurveySubmitContextValue => useContext(SurveySubmitContext)

type ProviderProps = {
	submitFnRef: React.MutableRefObject<(() => void) | null>
	dismissFnRef?: React.MutableRefObject<(() => void) | null>
	onClosePermanently: () => void
	setIsConfirmDisabled?: (disabled: boolean) => void
	children: React.ReactNode
}

export const SurveySubmitProvider: React.FC<ProviderProps> = ({ submitFnRef, dismissFnRef, onClosePermanently, setIsConfirmDisabled, children }) => (
	<SurveySubmitContext.Provider value={{ submitFnRef, dismissFnRef, onClosePermanently, setIsConfirmDisabled }}>
		{children}
	</SurveySubmitContext.Provider>
)
